import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir8865ScheduleOService {

  constructor(private http: HttpClient) { }

  /**
   * Load attribute names for tabs
   */
  loadAttributeNames(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=1vuc30";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Load Schedule O details
   */
  loadScheduleODetails(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=i45e84";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Load countries for FIR
   */
  getCountriesFIR(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=kbuwei";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Get Type of Property lookup
   */
  getTypeOfProperty(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=i9l17s";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Get Partner Details lookup
   */
  getPartnerDetails(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=x4g3o2";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Get Allocation Method lookup
   */
  getAllocationMethod(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=jzx0gy";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Get Gain Recognition lookup
   */
  getGainRecognition(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=0ovnb1";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Get Manner of Disposition lookup
   */
  getMannerOfDisposition(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = baseUrl + "/loadJsonObject?action_code=pc6cco";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save Reportable Transfer
   */
  saveReportableTransfer(
    baseUrl: string,
    scheduleSettings: any,
    scheduleDetails: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=qyicdf";
    
    const gp = globalService?.globalParams || {};
    let params = _.merge({}, gp, filterParams);
    
    params.jsonSettings = JSON.stringify(scheduleSettings);
    params.jsonObj = JSON.stringify(scheduleDetails);
    params.process_name = "save_Reportable_Transfer";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save Reportable Disposition
   */
  saveReportableDisposition(
    baseUrl: string,
    scheduleSettings: any,
    scheduleDetails: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=qyicdf";
    
    const gp = globalService?.globalParams || {};
    let params = _.merge({}, gp, filterParams);
    
    params.jsonSettings = JSON.stringify(scheduleSettings);
    params.jsonObj = JSON.stringify(scheduleDetails);
    params.process_name = "save_Reportable_Disposition";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save Supplemental Information
   */
  saveSupplementalInformation(
    baseUrl: string,
    scheduleSettings: any,
    scheduleDetails: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + "/saveJsonObject?action_code=qyicdf";
    
    const gp = globalService?.globalParams || {};
    let params = _.merge({}, gp, filterParams);
    
    params.jsonSettings = JSON.stringify(scheduleSettings);
    params.jsonObj = JSON.stringify(scheduleDetails);
    params.process_name = "save_Supplemental_Information";
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

